import React from 'react'

const SvgCreditCardFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 8H2V6c0-1.333.667-2 2-2h16c1.333 0 2 .667 2 2v2zm0 3v7c0 1.338-.667 2.005-2 2H4c-1.333.005-2-.662-2-2v-7h20zM9 14c-.667 0-1 .333-1 1 0 .665.333.998 1 .998h5c.667 0 1-.333 1-.999 0-.666-.333-.999-1-.999H9zm-4 0c-.667 0-1 .333-1 1 0 .665.333.998 1 .998h1c.667 0 1-.333 1-.999C7 14.333 6.667 14 6 14H5z'
    />
  </svg>
)

export default SvgCreditCardFilled
